import { Box, Button, Paper, Skeleton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUserSummary } from '../../../../hooks/useUserSummary';
import { useThemeColor } from '../../../../hooks/useThemeColor';
import { useLocalizedText } from '../../../../hooks/useLocalizedText';

export const UserSummaryCard = () => {
  const t = useLocalizedText();

  const navigate = useNavigate();

  const { userSummary } = useUserSummary();

  const { primary, secondary } = useThemeColor();

  return userSummary ? (
    <Paper
      elevation={3}
      sx={{
        px: 2.5,
        py: 6,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>
        {userSummary.firstName} {userSummary.lastName}
      </Typography>
      <Typography sx={{ fontSize: '14px' }}>{userSummary.email}</Typography>
      <Typography sx={{ fontSize: '14px' }}>{userSummary.phone}</Typography>

      <Box
        sx={{
          mt: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {!!userSummary.point && (
          <Typography>
            {t('account.user_summary.points', { points: userSummary.point })}
          </Typography>
        )}

        <Button
          onClick={() => {
            navigate('/hesabim/profil-duzenle');
          }}
          sx={{
            backgroundColor: primary,
            color: secondary,
            textTransform: 'none',
            fontWeight: 600,
            px: 2,
          }}
        >
          {t('account.user_summary.edit_profile')}
        </Button>
      </Box>
    </Paper>
  ) : (
    <Skeleton variant='rectangular' width='100%' height={250} />
  );
};
